<template>
  <div class="lds-dual-ring">
    <span class="ring" :style="{borderTopColor:color,borderBottomColor:color}"></span>
  </div>
</template>
<script>
export default {
  data () {
    return {
    }
  },
  props: ['color']
}
</script>
<style scoped lang='scss'>

.lds-dual-ring {
  display: inline-block;
  width: 64px;
  height: 64px;
}
.ring {
  display: block;
  width: 40px;
  height: 40px;
  margin: 1px;
  border-radius: 50%;
  border-width: 2px;
  border-style: solid;
  border-right-color: transparent;
  border-left-color: transparent;
  animation: lds-dual-ring 1.2s linear infinite;
}
@keyframes lds-dual-ring {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}

</style>
